import AxiosAPI from '../../../utils/AxiosAPI';

// Get All Services list when modal open
export const ApiGetAllServicesPackage = (role) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/setting/app-service/packages/${role}`)
            .get()
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

export const handleProductChangeLogo = (id, formData, setIsError) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/application/${id}/change-logo`)
            .put(formData)
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    setIsError(data.referenceName || '');
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });
export const handleSetProductSequence = (products) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/application/save-priorities`)
            .put(products)
            .then(({ data }) => {
                if (data?.status === 0) {
                    resolve(data);
                } else {
                    reject(data);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });
export const handleLoadProductDetailsOpe = (id) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/application/${id}/details`)
            .get()
            .then(({ data }) => {
                if (data?.status === 0) {
                    resolve(data);
                } else {
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

export const handleEditProductOpe = (id, formData, setIsError) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/application/${id}`)
            .put(formData)
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    setIsError(data.referenceName || '');
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

// Product Create when click on create button
export const handleCreateProductOpe = (formData, setIsError) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/application`)
            .post(formData)
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(data.title);
                    setIsError(data.referenceName);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });
// Get All Product list when page load
export const handleGetProductOpe = () =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/application`)
            .get()
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

// Get only active product list
export const ApiGetActiveProductListOpe = () =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/application/product-list`)
            .get()
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

// Package Add when click on add button
export const handleAddPackageOpe = (id, formData, setIsError) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/application/${id}/create-package`)
            .post(formData)
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(data.title);
                    setIsError(data.referenceName || '');
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

// Package Price Add when click on add button
export const handleAddPackagePriceOpe = (id, packageId, formData, setIsError) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/application/${id}/create-package-pricing/${packageId}`)
            .post(formData)
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(data.title);
                    setIsError(data.referenceName || '');
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

// Package Update when click on add button
export const handleUpdatePackageOpe = (id, packageId, formData, setIsError) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/application/${id}/update-package/${packageId}`)
            .put(formData)
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(data.title);
                    setIsError(data.referenceName || '');
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

// Package Price Update when click on add button
export const handleUpdatePackagePriceOpe = (id, packageId, pricingId, formData, setIsError) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/application/${id}/package/${packageId}/pricing/${pricingId}`)
            .put(formData)
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(data.title);
                    setIsError(data.referenceName || '');
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

// Package Price Delete when click on add button
export const handleDeletePackagePriceOpe = (id, packageId, pricingId) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/application/${id}/delete-package-pricing/${packageId}/${pricingId}`)
            .delete()
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

export default null;
